import { BASE_PATH_API } from '@root/manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';
import { ProjectDTO } from '@root/app/projects/data/dto/project.dto';
import { CreateProjectDTO } from '@root/app/projects/data/dto/create-project-dto';
import { UpdateProjectDTO } from '@root/app/projects/data/dto/update-project-dto';
import { CreateProjectTypeDTO } from '@root/app/projects/data/dto/create-project-type-dto';
import { IHttpParamSerializer } from 'angular';

const routeRoot = 'projects';
const baseRoute = `${BASE_PATH_API}/${routeRoot}`;

const actions = {
    getProject: {
        method: 'GET',
        url: `${baseRoute}/:id`
    },
    createProject: {
        method: 'POST',
        url: `${BASE_PATH_API}/projects`,
    },
    getAllProjects: {
        method: 'GET',
        url: `${BASE_PATH_API}/projects`,
        params: {
            '$count': true
        }
    },
    updateProject: {
        method: 'PUT',
        url: `${BASE_PATH_API}/projects/:id`,
    },
    deleteProject: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/projects/:id`,
    },
    getProjectTypes: {
        method: 'GET',
        url: `${BASE_PATH_API}/projectTypes`,
        params: {
            includeProjectCounts: false
        }
    },
    createProjectType: {
        method: 'POST',
        url: `${BASE_PATH_API}/projectTypes`,
    },
    updateProjectType: {
        method: 'PUT',
        url: `${BASE_PATH_API}/projectTypes/:id`,
    },
    deleteProjectType: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/projectTypes/:id`,
    }
};

export interface IProjectsApi {
    getProject(params: { id: number }): Promise<ProjectDTO>;
    createProject(createProjectDTO: CreateProjectDTO);
    getAllProjects(params: any);
    updateProject(params: { id: number }, updateProjectDTO: UpdateProjectDTO);
    deleteProject(params: { id: number });
    getProjectTypes(params: { includeProjectCounts: boolean });
    createProjectType(createProjectTypeDTO: CreateProjectTypeDTO);
    updateProjectType(params: { id: number }, updateProjectTypeDTO: CreateProjectTypeDTO);
    deleteProjectType(params: { id: number });
    getExportUrl(params: object): string;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function ProjectsApi($httpParamSerializer: IHttpParamSerializer): IProjectsApi {
    const service = createActions(actions);
    service.getExportUrl = (params: object) => {
        return `${BASE_PATH_API}/projects/export?${$httpParamSerializer(params)}`;
    };

    return service;
}

ProjectsApi.$inject = [
    '$httpParamSerializer'
];
